import React from 'react'

const SpinnerSVG = () => <svg width="48" height="47" viewBox="0 0 48 47" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M29.5 2C38.9888 4.42493 46 12.9774 46 23.1559C46 35.2201 36.1503 45 24 45C11.8497 45 2 35.2201 2 23.1559C2 21.1056 2.28448 19.1213 2.81639 17.2398" stroke="#4F4F4F" stroke-width="4" />
</svg>


export default function Spinner({
  spinner: Spinner = SpinnerSVG
}) {
  return (
    <div className="profile-picture-selector__spinner">
      <Spinner />
    </div>
  )
}
